module.exports = __webpack_public_path__ + "static/media/sql.59430506.svg";